/**
 * @typedef {Object} BookingOverviewCountsViewModelType
 * @property {string} dateLocal
 * @property {number} totalBookingsCount
 * @property {number} openBookingsCount
 */

/**
 * Class representing a booking overview view model.
 */
export class BookingOverviewCountsViewModel {
  /**
   * Create a booking overview view model.
   * @param {BookingOverviewCountsViewModelType} params
   */
  constructor(params) {
    this.dateLocal = params.dateLocal
    this.totalBookingsCount = params.totalBookingsCount
    this.openBookingsCount = params.openBookingsCount
  }
}
